"use client";
import { VelocityMarquee } from "@/components";

interface CaseStudyStripProps {
  items: string[];
  speed?: number;
  direction?: 1 | -1;
}

// A scroll-driven ribbon used twice on the page — once for the client roster,
// once for the stack. Same device, different payload and direction.
const CaseStudyStrip = ({
  items,
  speed = 0.35,
  direction = -1,
}: CaseStudyStripProps) => {
  return (
    <div className="mt-16 w-full border-y border-black/10 bg-black/[0.035] md:mt-24">
      <VelocityMarquee
        speed={speed}
        direction={direction}
        trackClassName="py-4 font-mono text-[11px] tracking-[0.16em] text-muted-foreground uppercase"
      >
        {items.map((item) => (
          <span key={item} className="pr-12 whitespace-nowrap">
            <span aria-hidden className="mr-3 text-primary">
              /
            </span>
            {item}
          </span>
        ))}
      </VelocityMarquee>
    </div>
  );
};

export default CaseStudyStrip;
